var _rect, _path, _rect2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCashIcon = function SvgCashIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.12601,
    y: 7.57907,
    width: 27,
    height: 17,
    rx: 3.5,
    transform: "rotate(4 4.12601 7.57907)",
    fill: "white",
    stroke: "#AEAEAE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4664 10.6449L8.51027 9.38932C8.39469 11.0421 6.96113 12.2883 5.30831 12.1727L4.75026 20.1533C6.40308 20.2688 7.64926 21.7024 7.53368 23.3552L25.4898 24.6108C25.6054 22.958 27.039 21.7118 28.6918 21.8274L29.2498 13.8469C27.597 13.7313 26.3508 12.2978 26.4664 10.6449ZM16.6513 21.9879C19.406 22.1805 21.7952 20.1036 21.9879 17.3489C22.1805 14.5942 20.1035 12.2049 17.3488 12.0123C14.5941 11.8196 12.2049 13.8966 12.0122 16.6513C11.8196 19.406 13.8966 21.7953 16.6513 21.9879ZM25.9781 17.6279C25.9396 18.1788 25.4617 18.5942 24.9108 18.5557C24.3599 18.5172 23.9445 18.0393 23.983 17.4884C24.0215 16.9374 24.4994 16.522 25.0503 16.5606C25.6013 16.5991 26.0167 17.0769 25.9781 17.6279ZM8.94978 17.4396C9.50072 17.4781 9.97858 17.0627 10.0171 16.5118C10.0556 15.9608 9.64023 15.483 9.0893 15.4445C8.53836 15.4059 8.0605 15.8213 8.02198 16.3723C7.98345 16.9232 8.39884 17.4011 8.94978 17.4396Z",
    fill: "#DDDDDD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 5.5,
    width: 27,
    height: 17,
    rx: 3.5,
    fill: "white",
    stroke: "#AEAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7H5C5 8.65685 3.65685 10 2 10V18C3.65685 18 5 19.3431 5 21H23C23 19.3431 24.3431 18 26 18V10C24.3431 10 23 8.65685 23 7ZM14 19C16.7614 19 19 16.7614 19 14C19 11.2386 16.7614 9 14 9C11.2386 9 9 11.2386 9 14C9 16.7614 11.2386 19 14 19ZM23 14C23 14.5523 22.5523 15 22 15C21.4477 15 21 14.5523 21 14C21 13.4477 21.4477 13 22 13C22.5523 13 23 13.4477 23 14ZM6 15C6.55228 15 7 14.5523 7 14C7 13.4477 6.55228 13 6 13C5.44772 13 5 13.4477 5 14C5 14.5523 5.44772 15 6 15Z",
    fill: "#DDDDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1532 13.5722C13.2613 13.3428 12.9745 13.1056 12.9745 12.7361C12.9745 12.3122 13.3713 12.0167 14.0354 12.0167C14.7348 12.0167 14.9941 12.3472 15.0177 12.8333H15.8861C15.8585 12.1644 15.446 11.55 14.6248 11.3517V10.5H13.446V11.34C12.6837 11.5033 12.0707 11.9933 12.0707 12.7439C12.0707 13.6422 12.8212 14.0894 13.9175 14.35C14.8998 14.5833 15.0963 14.9256 15.0963 15.2872C15.0963 15.5556 14.9037 15.9833 14.0354 15.9833C13.2259 15.9833 12.9077 15.6256 12.8644 15.1667H12C12.0472 16.0183 12.6916 16.4967 13.446 16.6561V17.5H14.6248V16.6639C15.391 16.52 16 16.0806 16 15.2833C16 14.1789 15.0452 13.8017 14.1532 13.5722Z",
    fill: "#DDDDDD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCashIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cash-icon.8e3f8120db9778a47fbcca7c610944f5.svg";